type ConditionalSuffix = string | false | null | undefined;

export const composeBemClasses = (
  block: string,
  suffixes: readonly string[],
  conditionalSuffixes: readonly ConditionalSuffix[],
  className?: string
): string => {
  const activeConditionalSuffixes = conditionalSuffixes.filter(
    (suffix): suffix is string => typeof suffix === 'string' && suffix.length > 0
  );
  const modifierClasses = [...suffixes, ...activeConditionalSuffixes].map((suffix) => `${block}--${suffix}`);
  const classNames = [block, ...modifierClasses];
  if (className) {
    classNames.push(className);
  }

  return classNames.join(' ');
};
